// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"358":"293c50e7","407":"a01133e7","779":"4ee29068"}[chunkId] + ".chunk.js";
};